import { forwardRef } from "react";

/**
 * Renders the chat history. Auto-scrolls the parent via a forwarded ref.
 * Purely presentational — session/SSE logic stays in the page component.
 */
export const MessageList = forwardRef(function MessageList({ messages, busy }, ref) {
  return (
    <div ref={ref} className="flex-1 overflow-auto p-5 space-y-4" data-testid="assistant-messages">
      {messages.map((m, idx) => (
        <MessageBubble key={m.id} message={m} index={idx} busy={busy} />
      ))}
    </div>
  );
});

function MessageBubble({ message, index, busy }) {
  const isUser = message.role === "user";
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        data-testid={`msg-${message.role}-${index}`}
        className={`max-w-[80%] rounded-md px-3 py-2 text-sm whitespace-pre-wrap leading-relaxed ${
          isUser
            ? "bg-slate-900 text-white"
            : "bg-slate-50 border border-slate-200 text-slate-900"
        }`}
      >
        {message.content || (busy && !isUser ? "…" : "")}
      </div>
    </div>
  );
}
